import { render } from "./IdField.vue?vue&type=template&id=05401686"
import script from "./IdField.vue?vue&type=script&lang=js"
export * from "./IdField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IdField.vue"]])

export default __exports__